/* Gleiche Titelhoehe je Produktraster, diXed 30.08.2026.
   Ronny: der Titel muss vollstaendig erscheinen, der laengste entscheidet.
   Ohne das rutscht der Preis bei zweizeiligem Titel um eine Zeile nach unten,
   gemessen 20 px Unterschied im selben Raster. */
(function () {
  var RASTER = '.contains-card--product';
  var TITEL = '.card__information .card__heading';

  function abgleichen() {
    var raster = document.querySelectorAll(RASTER);
    for (var i = 0; i < raster.length; i++) {
      var titel = raster[i].querySelectorAll(TITEL);
      if (titel.length < 2) continue;

      /* Zuruecksetzen, sonst waechst der Wert bei jedem Durchlauf. */
      for (var a = 0; a < titel.length; a++) {
        titel[a].style.minHeight = '';
      }

      var max = 0;
      for (var b = 0; b < titel.length; b++) {
        var h = titel[b].getBoundingClientRect().height;
        if (h > max) max = h;
      }
      if (max <= 0) continue;

      for (var c = 0; c < titel.length; c++) {
        titel[c].style.minHeight = max + 'px';
      }
    }
  }

  var uhr = null;
  function entprellt() {
    if (uhr) clearTimeout(uhr);
    uhr = setTimeout(abgleichen, 120);
  }

  /* Erst wenn die echten Schriften da sind. Gegen die Ersatzschrift gemessen
     waere die Hoehe falsch. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(abgleichen);
  } else {
    abgleichen();
  }
  window.addEventListener('load', abgleichen);
  window.addEventListener('resize', entprellt, { passive: true });

  /* Sicherheitsnetz: window.resize feuert nicht, wenn sich nur die
     Rasterbreite aendert, etwa beim Ein- und Ausklappen der Filter.
     Der Beobachter am Raster selbst greift in beiden Faellen. */
  if (window.ResizeObserver) {
    var beobachter = new ResizeObserver(entprellt);
    var raster = document.querySelectorAll(RASTER);
    for (var i = 0; i < raster.length; i++) {
      beobachter.observe(raster[i]);
    }
  }

  /* Dawn tauscht beim Filtern das ganze Raster aus. */
  var behaelter = document.getElementById('ProductGridContainer');
  if (behaelter && window.MutationObserver) {
    new MutationObserver(entprellt).observe(behaelter, {
      childList: true,
      subtree: true
    });
  }
})();
